import { type FC } from "react";
import { type PaymentFormData, type PurchasePrice } from "../types";
import { FormSectionHeader } from "../../../../../components/forms";
import FieldLabel from "../../../../../components/forms/FieldLabel";
import { CardIcon } from "../components/CardIcon";
import { formatMaskedCardNumber } from "../utils/formatPaymentData";
import OrderSummary from "../components/OrderSummary/OrderSummary";

import styles from "../PaymentModal.module.scss";

interface ConfirmationStepProps {
  goBack: () => void;
  paymentDetails: PaymentFormData;
  stateMapping: Record<string, string>;
  purchasePrice: PurchasePrice;
}

const ConfirmationStep: FC<ConfirmationStepProps> = (props) => {
  const { packs, creditCardInfo, billingInfo } = props.paymentDetails;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.confirmationSection}>
          <div className={styles.confirmationHeader}>
            <FormSectionHeader title="Credit Card Information" className={styles.title} />
            <button className={styles.editButton} onClick={props.goBack} type={"button"}>
              Edit
            </button>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"Name on Card"} />
            <p className={styles.value}>{creditCardInfo.nameOnCard}</p>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"Card Number"} />
            <p className={styles.value}>
              <CardIcon cardNumber={creditCardInfo.cardNumber} className={styles.creditCard} />{" "}
              {formatMaskedCardNumber(creditCardInfo.cardNumber)}
            </p>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"Expiration Date"} />
            <p className={styles.value}>
              {creditCardInfo.expirationMonth}/20{creditCardInfo.expirationYear}
            </p>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"Security Code"} />
            <p className={styles.value}>{creditCardInfo.securityCode}</p>
          </div>
        </div>

        <div className={styles.confirmationHeader}>
          <FormSectionHeader title="Billing Information" className={styles.title} />
          <button className={styles.editButton} onClick={props.goBack} type={"button"}>
            Edit
          </button>
        </div>
        <div className={styles.field}>
          <FieldLabel label={"Country/Region"} />
          <p className={styles.value}>{billingInfo.country}</p>
        </div>
        <div className={styles.field}>
          <FieldLabel label={"Street Address"} />
          <p className={styles.value}>{billingInfo.streetAddress}</p>
        </div>
        <div className={styles.addressFields}>
          <div className={styles.field}>
            <FieldLabel label={"City"} />
            <p className={styles.value}>{billingInfo.city}</p>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"State"} />
            <p className={styles.value}>{props.stateMapping[billingInfo.state]}</p>
          </div>
          <div className={styles.field}>
            <FieldLabel label={"Zip Code"} />
            <p className={styles.value}>{billingInfo.zipCode}</p>
          </div>
        </div>
      </div>
      <div className={styles.summary}>
        <OrderSummary packs={packs} purchasePrice={props.purchasePrice} />
      </div>
    </div>
  );
};

export default ConfirmationStep;
